import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';


@Component({
    selector: 'gender-type-form-dialog',
    templateUrl: './setting-form.component.html',
    styleUrls: ['./setting-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class GenderTypeDialogComponent implements OnInit {
  public form: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    enable: new FormControl(true),
    age: new FormControl('other'),
    defaultType: new FormControl(''),
    onlyForAdult: new FormControl(''),
  });
  defaultTypes = ['father', 'mother', 'godFather', 'godMother', 'sister', 'brother', 'son', 'daughter'];

  action: string;
  dialogTitle;
  genderType: any;

  constructor(
    public dialogRef: MatDialogRef<GenderTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any) {
    this.action = data.action;

    if (this.action === 'edit') {
      this.dialogTitle = 'edit_gender_type';
      this.genderType = data.type;
    } else {
      this.dialogTitle = 'new_gender_type';
    }
  }

  ngOnInit() {
    if (this.action === 'edit') {
      if (this.genderType.isChild) {
        this.genderType.age = 'child';
      }
      if (this.genderType.isAdult) {
        this.genderType.age = 'adult';
      }
      this.form.patchValue(this.genderType);
    }
  }

  save() {
    console.log(this.form);
    console.log(this.form.value);
    let data: any = Object.assign({}, this.form.value);
    if (data.age === 'child') {
      data.isChild = true;
      data.isAdult = false;
    }
    if (data.age === 'adult') {
      data.isChild = false;
      data.isAdult = true;
    }
    if (data.age === 'other') {
      data.isChild = false;
      data.isAdult = false;
    }
    if (this.action !== 'edit') {
      this.dialogRef.close(data);
    } else {
      this.dialogRef.close(['save', data]);
    }
  }

  delete() {
    this.dialogRef.close(['delete', this.form.value]);
  }
}
